import { RootState } from '../reducers';

export const getAllErrors = (state: RootState) => state.app.errors;

export const getAllNotices = (state: RootState) => state.app.notices;
